module.exports = __webpack_public_path__ + "static/media/SP_C_Embroidery_Vela_Dark grey_White.07862a99.png";